// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/search-widget.scss
// module id = 76
// module chunks = 0